import { notification } from 'antd';
import {
	GET_SETTINGS_START,
	GET_SETTINGS_SUCCESS,
	GET_SETTINGS_FAIL,
	UPDATE_SETTINGS_START,
	UPDATE_SETTINGS_SUCCESS,
	UPDATE_SETTINGS_FAIL,
} from 'admin/constants';
import * as endpoints from 'api';

export function getSettings() {
	return async dispatch => {
		try {
			dispatch({ type: GET_SETTINGS_START });

			const result = await endpoints.getSettings();

			if (result.success) {
				dispatch({ type: GET_SETTINGS_SUCCESS, payload: { ...result.data } });
			} else {
				dispatch({ type: GET_SETTINGS_FAIL });
			}
		} catch (e) {
			dispatch({ type: GET_SETTINGS_FAIL });
		}
	};
}

export function updateSettings(data) {
	return async dispatch => {
		try {
			dispatch({ type: UPDATE_SETTINGS_START });

			const result = await endpoints.updateSettings(data);

			if (result.success) {
				dispatch({ type: UPDATE_SETTINGS_SUCCESS, payload: { ...data } });
			} else {
				notification.error({
					message: 'Error!',
					description: result.message,
				});
				dispatch({ type: UPDATE_SETTINGS_FAIL });
			}
		} catch (e) {
			dispatch({ type: UPDATE_SETTINGS_FAIL });
		}
	};
}
